(function () {
  if (window.FitnessBentoBundleWeeklyMenuLoaded) {
    return;
  }

  window.FitnessBentoBundleWeeklyMenuLoaded = true;

  const STORAGE_KEY =
    'fitnessBentoDeliveryDay';


  /* =========================
     SHOW DELIVERY MENU
     ========================= */

  function showMenu(root, day) {
    if (!root) return;

    if (
      day !== 'monday' &&
      day !== 'saturday'
    ) {
      day = 'monday';
    }


    /* Update tabs */

    root
      .querySelectorAll(
        '[data-fb-weekly-menu-tab]'
      )
      .forEach(function (tab) {
        const isActive =
          tab.dataset.fbWeeklyMenuTab ===
          day;

        tab.setAttribute(
          'aria-selected',
          isActive ? 'true' : 'false'
        );
      });


    /* Update panels */

    root
      .querySelectorAll(
        '[data-fb-weekly-menu-panel]'
      )
      .forEach(function (panel) {
        const isActive =
          panel.dataset.fbWeeklyMenuPanel ===
          day;

        panel.hidden = !isActive;
      });
  }


  /* =========================
     INITIAL STATE
     ========================= */

  function initialiseMenu(root) {
    if (!root) return;

    let initialDay = 'monday';

    try {
      const savedDay =
        localStorage.getItem(
          STORAGE_KEY
        );

      if (
        savedDay === 'monday' ||
        savedDay === 'saturday'
      ) {
        initialDay = savedDay;
      }
    } catch (error) {
      /*
        Local storage may be unavailable.
        Monday remains the fallback.
      */
    }

    showMenu(
      root,
      initialDay
    );
  }


  function initialiseAllMenus() {
    document
      .querySelectorAll(
        '[data-fb-bundle-weekly-menu]'
      )
      .forEach(function (root) {
        initialiseMenu(root);
      });
  }


  /* =========================
     TAB CLICKS
     ========================= */

  document.addEventListener(
    'click',
    function (event) {
      const tab =
        event.target.closest(
          '[data-fb-weekly-menu-tab]'
        );

      if (!tab) return;

      const root =
        tab.closest(
          '[data-fb-bundle-weekly-menu]'
        );

      if (!root) return;

      const day =
        tab.dataset.fbWeeklyMenuTab;

      if (
        day !== 'monday' &&
        day !== 'saturday'
      ) {
        return;
      }

      /*
        This changes only the menu being
        previewed.

        It intentionally DOES NOT update
        fitnessBentoDeliveryDay because these
        tabs are informational rather than a
        delivery-day selection control.
      */
      showMenu(
        root,
        day
      );
    }
  );


  /* =========================
     INITIALISE
     ========================= */

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initialiseAllMenus
    );
  } else {
    initialiseAllMenus();
  }


  /* Shopify theme editor support */

  document.addEventListener(
    'shopify:section:load',
    function () {
      initialiseAllMenus();
    }
  );

})();